@if (!showPreview() || groups()?.length) {
  <div class="flex gap-6 items-center justify-center w-full">
    <mat-form-field class="w-full !min-w-[250px]" [subscriptSizing]="'dynamic'">
      <mat-label>{{
        label() ||
          ('CAMPAIGN_PERFORMANCE_FILTER_OFFER_IDS_SEARCH_TEXT' | translate)
      }}</mat-label>

      <input
        type="text"
        matInput
        [formControl]="formControl"
        [matAutocomplete]="auto"
        (focus)="onInputFocus($event)"
        (blur)="onInputBlur()"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn"
        (optionSelected)="onOptionSelected($event)"
      >
        @if (allOption()) {
          <mat-option [value]="''">{{ allOption() }}</mat-option>
        }
        @for (productGroup of filteredGroups(); track productGroup) {
          <mat-option [value]="productGroup">
            {{ productGroup.name | productGroupName }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    @if (showAddNew()) {
      <div>
        <em-fab-button
          matTooltip="{{ 'PRODUCT_FILTER_ADD_FILTERSET' | translate }}"
          icon="add"
          size="sm"
          (btnClick)="addNewClick.emit()"
        >
        </em-fab-button>
      </div>
    }
  </div>
}

@if (showPreview() && selectedGroup()) {
  <em-product-group-card
    class="max-w-[800px] w-full"
    [group]="selectedGroup()"
    (updated)="groupEdited.emit(selectedGroup()!)"
  >
  </em-product-group-card>
}

@if (showPreview() && !groups()?.length) {
  <em-add-new-item-card
    class="max-w-[350px] w-full"
    [title]="'PRODUCT_FILTER_ADD_FILTERSET' | translate"
    [asBox]="true"
    (click)="addNewClick.emit()"
  ></em-add-new-item-card>
  @if (required() && !groups()?.length) {
    <div class="text-center text-danger-500 -mt-6">
      {{ 'SHARED_REQUIRED_FIELD' | translate }}
    </div>
  }
}
